<template>
  <div class="pageFull categoryMain" :style="pageStyle">
    <div v-if="compositeMain && compositeMain.image" class="mainList">
      <div class="mainItem">
        <div class="img"><img :src="compositeMain.image" alt=""></div>
      </div>
    </div>
    <div v-else-if="compositeMain && compositeMain.banner" class="mainList contentPage">
      <div v-for="(item, index) in compositeMain.banner"
        :key="index"
        class="mainItem"
        @click.stop="setPage(item)">
        <div class="img"><img :src="item.image" alt=""></div>
        <!-- <div class="mainItemName" :style="nameSpacing">{{ item.categoryLabel[lang] }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryMain',
  props: [
    'locale',
    'lang',
    'pageId',
    'categoryId'
  ],
  computed: {
    getCategoryById () {
      return this.$store.getters['collection/getCategoryById'](this.categoryId)
    },
    pageStyle () {
      const frame = this.$store.getters['collection/getPageFrame']
      return {
        ...frame && {
          padding: `${frame}px`
        },
      }
    },
    compositeMain () {
      const categoryInfo = this.getCategoryById
      const mainType = categoryInfo.mainType
      return {
        [mainType]: mainType === 'image'
          ? categoryInfo.mainImage
          : categoryInfo.subCategory.map(item => {
            return {
              image: item.mainImage,
              categoryId: item.categoryId,
              categoryLabel: item.categoryLabel,
              useMain: item.useMain
            }
          })
      }
    },
    nameSpacing () {
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return spacing && spacing.name && {
        letterSpacing: spacing.name
      }
    }
  },
  methods: {
    setPage (item) {
      const routeName = item.useMain
        ? 'collectionCategoryMain'
        : 'collectionPage'
      this.$router.push({
        name: routeName,
        params: {
          ...this.$route.params,
          categoryId: item.categoryId
        }
      })
    }
  }
}
</script>